import { Dimensions } from "react-native"
import { useEffect, useState } from "react"

const DESKTOP_BREAKPOINT = 1023

const isDesktop = () => {
  return Dimensions.get("window").width >= DESKTOP_BREAKPOINT
}

export const useIsDesktop = () => {
  const [isDesktopValue, setIsDesktop] = useState(isDesktop())

  useEffect(() => {
    const subscription = Dimensions.addEventListener("change", () => {
      setIsDesktop(isDesktop())
    })
    return () => {
      subscription?.remove()
    }
  })

  return isDesktopValue
}
